import { render, staticRenderFns } from "./Timeline.vue?vue&type=template&id=64c6ddf9&scoped=true&"
import script from "./Timeline.vue?vue&type=script&lang=js&"
export * from "./Timeline.vue?vue&type=script&lang=js&"
import style0 from "./Timeline.vue?vue&type=style&index=0&id=64c6ddf9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c6ddf9",
  null
  
)

export default component.exports